import React from 'react';
import { Label } from 'app/components/ui/label';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormContext } from 'react-hook-form';

export default function LearningOutcomes() {
  const { setValue, watch } = useFormContext();
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
    ],
  };

  return (
    <div className="bg-white  dark:bg-transparent rounded-lg p-4 mb-6">
      <Label htmlFor="learning-outcomes">Learning Outcomes</Label>
      <ReactQuill
        id="learing-outcomes"
        modules={modules}
        theme="snow"
        value={watch('learning_outcomes')}
        onChange={value => setValue('learning_outcomes', value)}
      />
    </div>
  );
}
